"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const colors_1 = require("../../../styles/colors");
const Breadcrumb_1 = require("../../atoms/Breadcrumb/Breadcrumb");
const Typo_1 = require("../../atoms/Typo/Typo");
const SimpleButton_1 = require("../../atoms/SimpleButton/SimpleButton");
const PageTitle = (props) => {
    let alignItems;
    if (props.subTitle) {
        if (props.isBreadcrumbVisible) {
            alignItems = 'center';
        }
        else {
            alignItems = 'end';
        }
    }
    else {
        alignItems = 'start';
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "row", spacing: 2, alignItems: alignItems }, { children: [props.isArrowBackVisible && ((0, jsx_runtime_1.jsx)(SimpleButton_1.SimpleButton, Object.assign({ onClick: props.handleArrowBack, variant: props.buttonVariant, size: "small" }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.ArrowBack, { "data-testid": "arrow-back-button" }) }))), (0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "column" }, { children: [(0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ color: colors_1.$primaryNavy, variant: "subtitle3" }, { children: props.subTitle })), (0, jsx_runtime_1.jsxs)(Typo_1.Typo, Object.assign({ color: colors_1.$primaryNavy, variant: "h1" }, { children: [props.title, props.details && ((0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ color: colors_1.$primaryNavy, variant: "h1Light" }, { children: (0, jsx_runtime_1.jsxs)("em", { children: [" \u2014 ", props.details] }) })))] })), props.isBreadcrumbVisible && ((0, jsx_runtime_1.jsx)(Breadcrumb_1.Breadcrumb, { routes: props.breadcrumbRoutes, "data-testid": "breadcrumb-test-id" }))] }))] })));
};
exports.PageTitle = PageTitle;
